// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".qlcFE{overflow:hidden;margin:0 8px;border-radius:8px;cursor:pointer}@media screen and (min-width:400px){.qlcFE{margin:0 16px}}.CA1mr.qlcFE{background-image:none}.UmEbu{display:block;width:100%;height:50.6666666667vw;background:#e2e2e2;border-radius:8px 8px 0 0}.c\\+APW{border-radius:inherit;-o-object-fit:cover;object-fit:cover}.c\\+APW,.c\\+APW:after{width:100%;height:100%}.c\\+APW:after{position:absolute;top:0;left:0;padding:0;border:1px solid rgba(0,0,0,.1);border-bottom:0;border-radius:inherit}.OaVOC{background-color:#181716}.MBZ1y .OaVOC{border:1px solid #e2e2e2;border-top:0;background:#fff}.qlcFE ._67xyc{min-height:52px;padding-top:10px;padding-bottom:10px}.bF-b4{display:block}.qGsCN{padding:0 16px 26px;margin:0;color:#fff;font-family:\"Merriweather\",serif;font-size:22px;font-weight:700;line-height:28px}.MBZ1y .qGsCN{color:#2d2d2d}._4bjRZ .qGsCN{padding-bottom:20px}.\\+xncW{padding:0 16px 16px;margin:0;color:#c3c3c3;font-size:16px;font-weight:400;line-height:22px}.\\+xncW>span{-webkit-line-clamp:4;-webkit-box-orient:vertical;display:block;display:-webkit-box;overflow:hidden;max-height:88px}.qlcFE .LL5md{display:block;padding:0 16px 16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "qlcFE",
	"isRating": "CA1mr",
	"picture": "UmEbu",
	"image": "c+APW",
	"content": "OaVOC",
	"light": "MBZ1y",
	"header": "_67xyc",
	"body": "bF-b4",
	"title": "qGsCN",
	"withAdvertiser": "_4bjRZ",
	"subtitle": "+xncW",
	"advertiser": "LL5md"
};
module.exports = ___CSS_LOADER_EXPORT___;
